import DragVerify from './drag-verify.vue';
export default DragVerify;
